/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext } from 'react';
import intCommands from './commands';
import IntegrationContext from './IntegrationContext';
import BuilderContext from '../Context';
import commands from '../commands';

export default (): Element<string> => {
  const ctx = useContext(BuilderContext);
  const intCtx = useContext(IntegrationContext);
  const { navMode } = intCtx.state;
  const isLanding = navMode === 'LANDING';
  const txt = isLanding ? 'Forms' : 'Buttons';

  return (
    <div data-testid="IntegrationNavHeader">
      <h4>Integrations</h4>
      <hr />
      <a
        onClick={() => {
          if (isLanding) {
            commands(ctx).reset();
          } else {
            intCommands(intCtx).changeNav('LANDING');
          }
        }}
        tabIndex={0}
      >
        <i className="fa fa-arrow-left" /> {txt}
      </a>
      <hr />
    </div>
  );
};
